// Pieces shared by the chart definitions Studio builds (buildChartDefinition
// and buildTableDefinition)

export type ChartDefinitionResult =
  | { chartDefinition: V5ChartDefinition }
  // Why the block can't render yet, shown in the cell
  | { missing: string };

export const GROUP_LIMIT = 10;

export const DATE_DIMENSION: Dimension = {
  field: 'date',
  fieldType: 'date',
  isGroupByDayOfWeek: false,
  isGroupByMonth: false,
};
